import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Header from "../../components/Renewal/Header";
import TopBack from "../../components/Renewal/TopBack";
import { ModalBody } from "react-bootstrap";

const Property = (props) => {
	const [add, setAdd] = useState(true);
	const [firstLoad, setFirstLoad] = useState(true);

	const renewalData = useSelector((state) => state.RenewalData);
	const renewalId = useSelector((state) => state.RenewalId);

	const dispatch = useDispatch();
	let history = useHistory();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (renewalData && firstLoad) {
			setFirstLoad(false);
			setAdd(_.get(renewalData, `covers_misc_damage`, false));
		}
	}, [renewalData]);

	useEffect(() => {
		changeProperty(add);
	}, [add]);

	const changeProperty = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, covers_misc_damage: value }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};

	return (
		<div className="property general d-flex justify-content-center">
			<div className="otcontainer1 nopadding">
				<TopBack />
				<div className="col">
					<div className="">
						<h1 className="otmt-2 otmb-2" style={{ color: "#00778a" }}>
							Property Protection
						</h1>
						<p className="mt-3">
							Add coverage to you policy for tools, parts, equipment and gear
							you store and use at the track.
						</p>
						<p className="mt-3">
							Adding this coverage adds $25,000 of Miscellaneous Property
							Coverage for an additional $41.67 + taxes per month.
						</p>
					</div>
				</div>

				<div className="d-flex justify-content-center col-12">
					<div className="otmt-2">
						<input
							type="radio"
							className="btn-check"
							name="btnradio"
							id="btnradio1"
							autoComplete="off"
							onClick={() => {
								setAdd(!add);
							}}
						/>
						<label
							className={`col-11 col-md-6 btn3 mb-2 ${
								add === true && "active"
							}`}
							htmlFor="btnradio1"
							style={{ maxWidth: "328px", minWidth: "300px" }}
						>
							{`${add === true ? "Remove" : "Add"}`} Property Coverage
						</label>
					</div>
				</div>

				<div className="d-flex justify-content-center otmt-4 otmb-4">
					<button className="btn btn-lg btn2" onClick={() => history.goBack()}>
						SAVE AND EXIT
					</button>
				</div>
			</div>
		</div>
	);
};

export default Property;
